export default {
  getEntities: state => {
    return state.entitiesById.map(entityId => state.entities[entityId]);
  },
  getEntityEvents: state => {
    return state.entityEventsById.map(entityId => state.entityEvents[entityId]);
  },
  // TODO: Ask API to integrate static entities to /entites list
  getStaticEntities: state => {
    return state.staticEntitiesById.map(
      entity_id => state.staticEntities[entity_id]
    );
  },

  getStaticEntitiesById: state => {
    return state.staticEntities;
  },
};
